import { useState, useEffect, useCallback } from 'react';
import { API_URL } from '../constants/api';

// Single initialization hook that fetches all user data in one API call
export function useInit(deviceId) {
  const [data, setData] = useState({
    credits: 0,
    isAdmin: false,
    hasSubscription: false,
    subscriptionStatus: null,
    subscriptionEnd: null,
    authenticated: false,
    userEmail: null,
    loaded: false,
  });

  const fetchInit = useCallback(async () => {
    if (!deviceId) return;

    try {
      const response = await fetch(`${API_URL}/api/init/${deviceId}`, {
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.json();

      setData({
        credits: result.credits || 0,
        isAdmin: result.isAdmin || false,
        hasSubscription: result.hasSubscription || false,
        subscriptionStatus: result.subscriptionStatus,
        subscriptionEnd: result.subscriptionEnd,
        authenticated: result.authenticated || false,
        userEmail: result.userEmail,
        loaded: true,
      });

      // Also cache credits in localStorage as fallback
      localStorage.setItem('swingslot_credits', (result.credits || 0).toString());
    } catch (error) {
      console.error('Init fetch failed:', error);

      // Fall back to cached credits
      const cachedCredits = localStorage.getItem('swingslot_credits');
      setData(prev => ({
        ...prev,
        credits: cachedCredits ? parseInt(cachedCredits, 10) : 0,
        loaded: true,
      }));
    }
  }, [deviceId]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  return { ...data, refetch: fetchInit };
}
